import { Skeleton } from 'antd';

const WorkflowItemVerticalSkeleton = () => (
  <div
    style={{
      maxWidth: 200,
      padding: 8,
      width: '100%',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
    }}
  >
    <Skeleton.Image
      style={{
        width: '100%',
        minHeight: 180,
        borderRadius: 8,
        marginBottom: 12,
        display: 'flex',
      }}
      active
    />
    <Skeleton active paragraph={{ rows: 2 }} title={false} style={{ marginBottom: 8 }} />
    <div style={{ display: 'flex', gap: 8 }}>
      <Skeleton.Button active style={{ width: '48%', height: 32, borderRadius: 10 }} />
      <Skeleton.Button active style={{ width: '48%', height: 32, borderRadius: 10 }} />
    </div>
  </div>
);

export default WorkflowItemVerticalSkeleton;
